import { render, staticRenderFns } from "./UserActivityDetails.vue?vue&type=template&id=3c320dfc&scoped=true"
import script from "./UserActivityDetails.vue?vue&type=script&lang=js"
export * from "./UserActivityDetails.vue?vue&type=script&lang=js"
import style0 from "./UserActivityDetails.vue?vue&type=style&index=0&id=3c320dfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c320dfc",
  null
  
)

export default component.exports